// import external dependencies
import "jquery"
import "alpinejs"
import smoothscroll from "smoothscroll-polyfill"
import "slick-carousel"
import Glide from "@glidejs/glide"

smoothscroll.polyfill()

// Import everything from autoload


// import local dependencies
import Router from "./util/Router"
import common from "./routes/common"

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
})

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents()
  $("[data-slick]").slick({
    rows: 0,
  })
  if (jQuery("#upcoming-events").length > 0) {
    new Glide("#upcoming-events", {
      perView: 2,
      gap: 20,
      peek: {
        before: 0,
        after: 200,
      },
      breakpoints: {
        900: {
          perView: 1,
          peek: {
            before: 0,
            after: 200,
          },
        },
        600: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          },
        },
      },
    }).mount()
  }
})



// WEBPACK FOOTER //
// ./scripts/main.js